import { Box, Button, Card, CardActions, CardContent, Divider, FormControlLabel, Radio, RadioGroup, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import { INPUT_DESCRIPTION, INPUT_ZONE_LIMIT, RESTRICT_SPEC_CHARACTER } from '../../../../constants'
import { useLanguageLocale } from '../../../../hooks/language-locale-hooks';
import * as PXBColors from '@brightlayer-ui/colors';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import EditIcon from '@mui/icons-material/Edit';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

type Props = {

}

const SetOutputs = (props: Props) => {
    const { t } = useLanguageLocale();
    const [relayName, setRelayName] = React.useState("");
    const [description, setDescription] = useState("")

    const handleRelayName = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const value = event.target.value;
        if (value === '' || RESTRICT_SPEC_CHARACTER.test(value)) {
            setRelayName(value);
        }
    }

    const handleDescriptionChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const value = event.target.value;
        if (value === '' || RESTRICT_SPEC_CHARACTER.test(value)) {
            setDescription(value);
        }
    }

    return (
        <Box data-testid="output-container"
            style={{
                marginRight: '8%',
                marginLeft: '5%',
                marginTop: '1%',
                width: "130%"
            }}>
            <Typography sx={{ display: 'flex', gap: '1%' }} fontWeight={400} data-testid='output-description'>
                <InfoOutlinedIcon /> {t('ASSETS_DETAILS.SET_OUTPUT_DESCRIPTION')}
            </Typography>
            <Card data-testid="relay-field-container" style={{ flex: '1 1 0px', overflow: 'auto', marginTop: '5%' }} >
                <CardContent>
                    <Typography fontSize={20} fontWeight={600} data-testid='output-title'>
                        {t('ASSETS_DETAILS.RELAY')}
                    </Typography>
                    <Typography variant="subtitle1" fontSize={16} sx={{ marginBottom: '2' }} fontWeight={400} data-testid='output-subtitle'>
                        {t('ASSETS_DETAILS.OPTIONAL_OUTPUTS')}
                    </Typography>
                    <Box style={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: '5%',
                        justifyContent: 'start',
                        marginTop: '2%',
                    }}>
                        <Box style={{ width: '100%' }}>
                            <TextField
                                id='RelayName'
                                inputProps={{ 'data-testid': 'RelayName', maxLength: INPUT_ZONE_LIMIT }}
                                variant="filled" fullWidth
                                placeholder={t('ASSETS_DETAILS.PLACEHOLDER_TEXT')}
                                label={t('ASSETS_DETAILS.RELAY_NAME')}
                                value={relayName}
                                onChange={handleRelayName}
                            />
                            <div data-testid='relayNameHelperTextId'
                                style={{ height: 17, width: '100%', color: PXBColors.gray[500] }}>
                                <small className="form-text" style={{ width: '85%', float: 'left', paddingLeft: '2%' }}>
                                    {t('ORGANIZATION_MANAGE.ORGANIZATION_NAME_HELPER')}</small>
                                <Typography data-testid='relayNameLimitId' style={{ width: 'auto', float: 'right', fontSize: 12, color: PXBColors.gray[500] }}>
                                    {relayName.length || 0}/{INPUT_ZONE_LIMIT}
                                </Typography>
                            </div>
                        </Box>
                        <Box style={{ width: '100%' }}>
                            <TextField
                                id="DescriptionField"
                                inputProps={{ 'data-testid': 'DescriptionField', maxLength: INPUT_DESCRIPTION }}
                                variant="filled" fullWidth
                                label={t('LOGBOOK_DETAILS.DESCRIPTION')}
                                placeholder={t('ASSETS_DETAILS.PLACEHOLDER_TEXT')}
                                value={description}
                                onChange={handleDescriptionChange}
                            />
                            <div data-testid='DescriptionHelperTextId'
                                style={{ height: 17, width: '100%', color: PXBColors.gray[500] }}>
                                <small className="form-text" style={{ width: '85%', float: 'left', paddingLeft: '2%' }}>
                                    {t('ORGANIZATION_MANAGE.ORGANIZATION_NAME_HELPER')}</small>
                                <Typography data-testid='DescriptionCharLengthId' style={{ width: 'auto', float: 'right', fontSize: 12, color: PXBColors.gray[500] }}>
                                    {description.length || 0}/{INPUT_DESCRIPTION}
                                </Typography>
                            </div>
                        </Box>
                    </Box>
                    <Box sx={{ marginTop: 5 }} data-testid="output-radio-button">
                        <Typography sx={{ display: 'flex', gap: '1%' }} fontSize={16} fontWeight={600} data-testid='communication-method-title'>
                            {t('ASSETS_DETAILS.COMMUNICATION_METHOD')} <HelpOutlineIcon />
                        </Typography>
                        <RadioGroup name="controlled-radio-buttons-group" data-testid="communication-output-radio" style={{ marginTop: '15px' }}>
                            <FormControlLabel style={{ fontSize: '14px', margin: 0, padding: 0, color: '#424E54', fontWeight: 400 }} value="notconfigured" control={<Radio />} label={t('DRY_CONTACT.IOSTATUS.NOT_CONFIGURED')} />
                            <FormControlLabel style={{ fontSize: '14px', margin: 0, padding: 0, color: '#424E54', fontWeight: 400 }} value="open" control={<Radio />} label={t('DRY_CONTACT.NORMALLY_OPEN')} />
                            <FormControlLabel style={{ fontSize: '14px', margin: 0, padding: 0, color: '#424E54', fontWeight: 400 }} value="closed" control={<Radio />} label={t('DRY_CONTACT.NORMALLY_CLOSED')} />
                        </RadioGroup>
                    </Box>
                    <Divider />
                </CardContent>
                <CardActions style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                    <Button sx={{ width: '50%' }} variant='outlined' startIcon={<EditIcon />} data-testid='configure-output-functions-button'>
                        {t('ASSETS_DETAILS.CONFIGURE_RELAY_FUNCTION')}
                    </Button>
                </CardActions>

            </Card>
        </Box>
    )
}

export default SetOutputs
